export enum HgLocalStorageKey {
  VISITED_LISTING_IDS = 'v_l_i',
  HIDDEN_LISTING_IDS = 'hiddenListingIds',
}
